module.exports = __webpack_public_path__ + "static/img/RyanPapenhuyzen.f416d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RyanPapenhuyzen.jpg
// module id = +7r9
// module chunks = 0